export const LAIS_APP_FRAME_CLASS =
  'lais-app-frame flex h-full min-h-0 w-full flex-1 overflow-hidden font-laisBody text-lais-text';

// Accessible focus ring shared by interactive LAIS surfaces. Backed by the
// `--lais-focus-ring` token (see _lais-tokens.scss) and `shadow-lais-focus`.
export const LAIS_FOCUS_RING_CLASS =
  'lais-focus-ring focus-visible:outline-none focus-visible:shadow-lais-focus';

export const LAIS_APP_MAIN_CLASS =
  'lais-app-main relative flex h-full min-h-0 min-w-0 flex-1 overflow-hidden bg-lais-bg-page';

export const LAIS_ROUTER_VIEWPORT_CLASS =
  'lais-router-viewport relative h-full min-h-0 w-full min-w-0 flex-1 overflow-x-hidden overflow-y-auto p-0 md:overflow-hidden';

export const LAIS_PAGE_SHELL_CLASS =
  'lais-page-shell flex h-full min-h-0 w-full min-w-0 flex-col overflow-x-hidden overflow-y-auto rounded-lais-sm border border-lais-border-rule bg-white font-laisBody text-lais-text md:overflow-hidden';

export const LAIS_PAGE_SCROLL_SHELL_CLASS =
  'lais-page-shell flex h-full min-h-0 w-full min-w-0 flex-col overflow-auto rounded-lais-sm border border-lais-border-rule bg-white font-laisBody text-lais-text';

export const LAIS_PAGE_PADDING_CLASS = 'px-4 pb-6 sm:px-6 lg:px-10';

export const LAIS_SETTINGS_WRAPPER_CLASS =
  'lais-settings-wrapper flex h-full min-h-0 w-full overflow-auto rounded-lais-sm border border-lais-border-rule bg-white p-4 font-laisBody text-lais-text sm:p-6';

export const LAIS_SETTINGS_WRAPPER_INNER_CLASS =
  'lais-settings-wrapper-inner flex w-full max-w-none min-w-0 items-start';

export const LAIS_SIDEBAR_CLASS =
  'lais-sidebar fixed inset-y-0 left-0 z-40 flex h-[100dvh] w-[204px] max-w-[calc(100vw-1rem)] shrink-0 flex-col border-r border-lais-border-rule bg-white font-laisBody transition-transform duration-200 lg:static lg:h-full lg:max-w-none lg:translate-x-0';

export const LAIS_SIDEBAR_HEADER_CLASS =
  'flex h-16 shrink-0 items-center gap-2 border-b border-lais-border-rule px-6';

export const LAIS_SIDEBAR_SECTION_TITLE_CLASS =
  'text-lais-label-xs font-semibold uppercase tracking-[0.06em] text-lais-text-muted';

export const LAIS_SIDEBAR_LINK_CLASS =
  'group relative flex h-11 items-center gap-3 pl-6 pr-4 text-lais-body-md transition-colors';

export const LAIS_SIDEBAR_ACTIVE_LINK_CLASS =
  'bg-lais-primary-50 text-lais-primary font-semibold';

export const LAIS_SIDEBAR_INACTIVE_LINK_CLASS =
  'text-lais-text hover:bg-lais-primary-50/30';

export const LAIS_SIDEBAR_ACTIVE_ICON_CLASS = 'text-lais-primary';

export const LAIS_SIDEBAR_INACTIVE_ICON_CLASS = 'text-lais-icon';

export const LAIS_SIDEBAR_BADGE_CLASS =
  'rounded-full border border-lais-border px-2 py-0.5 text-lais-label-xs font-semibold uppercase tracking-wide text-lais-primary';

export const LAIS_SIDEBAR_FOOTER_CLASS =
  'flex h-16 shrink-0 items-center gap-3 border-t border-lais-border-rule px-4';

export const LAIS_SIDEBAR_AVATAR_CLASS =
  'flex size-9 shrink-0 items-center justify-center rounded-full bg-lais-primary-50 font-redHatDisplay text-lais-label-sm font-semibold text-lais-primary';

export const LAIS_LOGIN_MAIN_CLASS =
  'flex min-h-screen w-full bg-lais-bg-page font-laisBody text-lais-text';

export const LAIS_LOGIN_DESKTOP_PANEL_CLASS =
  'relative hidden w-1/2 flex-col justify-between overflow-hidden bg-lais-primary-deep px-16 py-14 text-white lg:flex';

export const LAIS_LOGIN_DESKTOP_PANEL_FRAME_CLASS =
  'pointer-events-none absolute inset-2 rounded-lais-sheet border-2 border-b-0 border-lais-mint';

export const LAIS_LOGIN_MOBILE_PANEL_CLASS =
  'mb-5 flex w-full max-w-md flex-col gap-3 rounded-lais-sheet bg-lais-primary-deep px-6 py-6 text-white shadow-lais-pop lg:hidden';

export const LAIS_LOGIN_CARD_CLASS =
  'w-full max-w-md rounded-lais-sheet border border-lais-border bg-white px-6 py-8 shadow-lais-pop sm:px-8';

export const LAIS_LOGIN_LINK_CLASS =
  'text-lais-primary-deep transition-colors hover:text-lais-primary';

export const LAIS_LOGIN_PRIMARY_BUTTON_CLASS =
  'mt-2 w-full rounded-lg bg-lais-primary-deep py-3 text-base font-semibold text-white transition-colors hover:bg-lais-primary-700 disabled:opacity-50';

export const LAIS_LOGIN_STACK_CLASS =
  'flex min-h-screen w-full flex-col bg-lais-bg-page px-4 py-10 font-laisBody text-lais-text sm:px-6 lg:px-8';
